<template>
  <div>
    <DialogInfo title="Manage teams" :visible="visible" size @hidden="hidden">
      <b-form-group
        label="Manage teams"
        description="Kicking a team removes it from the quiz and deletes its scores.."
      >
        <b-form-select v-model="selectedTeam" class="mb-2">
          <b-form-select-option v-for="t in teams" :key="t.id" :value="t">{{
            t.name
          }}</b-form-select-option>
        </b-form-select>
        <b-button block variant="warning" @click="askKickTeam"
          >Kick team</b-button
        >
      </b-form-group>
      <b-form-group
        label="Clean up"
        description="Removes all teams that have not submitted any scores yet. The removed teams can join in again, as long as your quiz is still open."
      >
        <b-button block variant="warning" @click="askCleanUpTeams"
          >Remove idle teams</b-button
        >
      </b-form-group>
    </DialogInfo>
    <DialogError v-model="errorVisible">{{ errorMessage }}</DialogError>
    <DialogYesNo v-model="confirmationVisible" @ok="actionConfirmed">{{
      confirmationMessage
    }}</DialogYesNo>
  </div>
</template>

<script>
import DialogError from "@/components/DialogError";
import DialogYesNo from "@/components/DialogYesNo";
import DialogInfo from "@/components/DialogInfo";

export default {
  name: "HostManageTeamsDialog",
  components: { DialogInfo, DialogYesNo, DialogError },
  props: {
    quizID: {
      default: 0
    },
    visible: {
      default: false
    }
  },
  model: {
    prop: "visible",
    event: "updateVmodel"
  },
  data() {
    return {
      teams: [],
      selectedTeam: null,
      errorMessage: "",
      errorVisible: false,
      confirmationMessage: "",
      confirmationVisible: false,
      actionOnConfirm: null
    };
  },
  created() {
    this.$topquiz.on(this, "host_getCurrentQuizTeams_success", params => {
      this.teams = params[0];
    });

    this.$topquiz.sendCommand(
      "host_getCurrentQuizTeams",
      this.$topquiz.SessionKey,
      this.quizID
    );
  },
  destroyed() {
    this.$topquiz.unsubscribe(this);
  },
  methods: {
    hidden() {
      this.$emit("updateVmodel", false);
    },
    actionConfirmed() {
      if (!this.actionOnConfirm) {
        return;
      }

      eval("this." + this.actionOnConfirm + "();");
      this.actionOnConfirm = null;
    },
    askCleanUpTeams() {
      this.actionOnConfirm = "cleanUpTeams";
      this.confirmationMessage =
        "You are about to remove all teams from the quiz that have not scored a single round yet. Are you sure?";
      this.confirmationVisible = true;
    },
    cleanUpTeams() {
      this.$topquiz.sendCommand(
        "host_kickIdleTeams",
        this.$topquiz.SessionKey,
        this.quizID
      );
    },
    askKickTeam() {
      if (!this.selectedTeam) {
        this.errorMessage = "You must select a team first...";
        this.errorVisible = true;
        return;
      }

      this.actionOnConfirm = "kickTeam";
      this.confirmationMessage =
        "You are about to kick '" + this.selectedTeam.name + "'. Are you sure?";
      this.confirmationVisible = true;
    },
    kickTeam() {
      this.$topquiz.sendCommand(
        "host_kickTeam",
        this.$topquiz.SessionKey,
        this.quizID,
        this.selectedTeam.id
      );
    }
  }
};
</script>
